import useIsEditing from 'lib/hooks/useIsEditing';

/**
 * Props to put on existing host nodes Pages mutates before hydration
 * (`cursor: pointer`, `tabindex`). Omit when not editing so published HTML is unchanged.
 */
export function editingHydrationProps(isEditing: boolean) {
  return isEditing ? { suppressHydrationWarning: true as const } : {};
}

export function useEditingHydrationProps() {
  const isEditing = useIsEditing();
  return editingHydrationProps(isEditing);
}

export default useEditingHydrationProps;
